export default "__VITE_ASSET__CA6biD82__"